<template>
    <router-view></router-view>
</template>

<script>
import "../scss/default.scss";
export default {
    name: "app-modules"
}
</script>